import axiosGlobalInstance from '../http-instance';
import { getCookie, decryptAes } from '../../utils';

const listCalendars = () => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  return axiosGlobalInstance({
    method: 'GET',
    url: '/integration.calendar.php',
    headers: {
      token: decipher?.token?.value,
      action: 'listCalendars',
    }
  });
}

export default listCalendars;
